// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tabs-component-tabs {\n\tdisplay: flex;\n}\n.tabs-component-tab {\n\tflex-grow: 1;\n\ttext-align: center;\n\tcolor: var(--color-text-lighter);\n}\n.tabs-component-tab.is-active {\n\tborder-bottom: 1px solid black;\n\tfont-weight: bold;\n}\n.tabs-component-panels {\n\tpadding-top: 20px;\n}\n.tabs-component-panels label {\n\ttext-align: left;\n\twidth: 100%;\n\tdisplay: inline-block;\n}\n.tabs-component-panels input,\n.tabs-component-panels select {\n\tmargin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
